'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/secondBefore.js
// module id = 732
// module chunks = 0